import { Avatar as MuiAvatar } from '@mui/material';

export default MuiAvatar;
